<div class='header' [ngClass]="{'header-thank-you' : !formService.formActive}">
	<div class='container'>
		<div class='content'>
			<div class='mobile-leo'>
				<a [href]='getHomeUrl()'>
					<mat-icon svgIcon='icons:sir-leo-headshot'></mat-icon>
				</a>
			</div>
			<div class='logo'>
				<a [href]='getHomeUrl()'>
					<mat-icon svgIcon='images:logo'></mat-icon>
				</a>
			</div>
		</div>
	</div>
</div>